import { useState } from 'react';
import Button from '@/components/primitives/Button.jsx';
import Input from '@/components/primitives/Input.jsx';
import AuthNotice from './AuthNotice.jsx';
import MIN_PASSWORD_LENGTH from '../lib/MIN_PASSWORD_LENGTH.js';

/**
 * A new password typed twice (reset and invite acceptance). `onSubmit({ password, name })` returns
 * an error sentence, or nothing on success. `askName` adds an optional name field.
 */
const NewPasswordForm = ({ submitLabel, askName = false, onSubmit }) => {
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isShort = password.length > 0 && password.length < MIN_PASSWORD_LENGTH;
  const isMismatch = confirmation.length > 0 && confirmation !== password;

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setIsSubmitting(true);
    const failure = await onSubmit({ password, name: name.trim() || undefined });

    if (failure) {
      setIsSubmitting(false);
      setError(failure);
    }
  };

  return (
    <form className="auth-form" onSubmit={handleSubmit} noValidate>
      <AuthNotice>{error}</AuthNotice>
      {askName && <Input label="Your name" name="name" autoComplete="name" value={name} onChange={(event) => setName(event.target.value)} />}
      <Input label="New password" type="password" name="new-password" autoComplete="new-password" value={password} onChange={(event) => setPassword(event.target.value)} hint={isShort ? undefined : `At least ${MIN_PASSWORD_LENGTH} characters.`} error={isShort ? `Use at least ${MIN_PASSWORD_LENGTH} characters.` : undefined} required />
      <Input label="Confirm password" type="password" name="confirm-password" autoComplete="new-password" value={confirmation} onChange={(event) => setConfirmation(event.target.value)} error={isMismatch ? 'The two passwords do not match.' : undefined} required />
      <div className="auth-form__submit">
        <Button type="submit" variant="primary" size="lg" loading={isSubmitting} disabled={password.length < MIN_PASSWORD_LENGTH || confirmation !== password}>
          {submitLabel}
        </Button>
      </div>
    </form>
  );
};

export default NewPasswordForm;
